import React from "react"
import "../Styles/index.scss"
import TopMusics from "./musicHome/topmusics"
import Albums from "./musicHome/albums"
import Musicvideos from "./musicHome/musicvideos"
import Newmusics from "./musicHome/newmusics"

const SongsHome = () => {
  return (
    <div>
      <div>
        {/* top songs */}
        <TopMusics />
      </div>
     <br/>
     <div>
        {/* new songs */}
        <Newmusics />
      </div>
      <br/>
      <div>
        {/* musicvideos songs */}
        <Musicvideos />
      </div>
      <br/>
      <div>
        {/* top songs */}
        <Albums />
      </div>
      
    </div>
    
  )
}

export default SongsHome
